import { OnInit, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
var RadioGroupComponent = /** @class */ (function () {
    function RadioGroupComponent() {
        this.propagateChange = function () { };
        this.onTouched = function () { };
        this.modelChange = new EventEmitter();
        this.values = [];
        this._model = '';
    }
    RadioGroupComponent.prototype.ngOnInit = function () { };
    RadioGroupComponent.prototype.ngOnChanges = function (changes) {
    };
    // Called when form is initialized, with form model's initial value
    RadioGroupComponent.prototype.writeValue = function (value) { if (value)
        this.model = value; };
    // Access to a function that informs the outside world about changes
    RadioGroupComponent.prototype.registerOnChange = function (fn) { this.propagateChange = fn; };
    // Allows Angular to register a function to call when the input has been touched.
    // Save the function as a property to call later here.
    RadioGroupComponent.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    Object.defineProperty(RadioGroupComponent.prototype, "model", {
        get: function () { return this._model; },
        set: function (val) {
            this._model = val;
            this.propagateChange(this._model);
            this.modelChange.emit();
            this.onTouched();
        },
        enumerable: true,
        configurable: true
    });
    RadioGroupComponent.prototype.trackBy = function (index, elem) {
        return elem.value;
    };
    return RadioGroupComponent;
}());
export { RadioGroupComponent };
var RadioButton = /** @class */ (function () {
    function RadioButton() {
    }
    return RadioButton;
}());
export { RadioButton };
